import { EventEmitter } from 'events';

export enum CustomEvents {
    UcasUpdates = 'UCAS-UPDATED',
    FavouriteCookieUpdated = 'FAVOURITE-COOKIE-UPDATED'
}

// Create and export an instance of EventEmitter
const emitter = new EventEmitter();
emitter.setMaxListeners(20);
export default emitter;
